// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyAi6YvYiRYLFBS13wniyGr-UbshnFoBdRc",
  authDomain: "cloudburst-code-challenge.firebaseapp.com",
  databaseURL: "https://cloudburst-code-challenge.firebaseio.com",
  projectId: "cloudburst-code-challenge",
  storageBucket: "cloudburst-code-challenge.appspot.com",
  messagingSenderId: "29118136254",
  appId: "1:29118136254:web:77b91e5c7672218f4ec3ef",
  measurementId: "G-6452JFGXJJ"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
